// useFcm.ts
import { useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { useSetRecoilState } from 'recoil';
import { FcmTokenAtom } from 'modules/fcm';
import { useAsync } from 'hooks/useAsync';
import { usePkgCheck } from 'hooks';
import { PKG_1, PKG_2, PKG_4 } from 'constants/const';

const audioCtx = new AudioContext();

function unlockAudio() {
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(console.error);
  }
  document.removeEventListener('click', unlockAudio);
  document.removeEventListener('touchstart', unlockAudio);
}
document.addEventListener('click', unlockAudio);
document.addEventListener('touchstart', unlockAudio);

export const useFcm = () => {
  const { showAlarm, closeAlarm } = useAsync();
  const setFcmToken = useSetRecoilState(FcmTokenAtom);
  const sosAudioRef = useRef<HTMLAudioElement>(new Audio('/assets/audio/ping.mp3'));
  const { pkgNo } = usePkgCheck();

  useEffect(() => {
    if (!pkgNo) {
      return;
    }

    let firebaseConfig = {};
    let vapidKey: string;

    switch (pkgNo) {
      case PKG_1:
      case PKG_4:
        firebaseConfig = {
          apiKey: 'AIzaSyBJZdxBarqapPxHOOdrCSSTYyF_2GIXZQQ',
          authDomain: 'fgiprfid-com.firebaseapp.com',
          projectId: 'fgiprfid-com',
          storageBucket: 'fgiprfid-com.firebasestorage.app',
          messagingSenderId: '1073172540674',
          appId: '1:1073172540674:web:085919f1adf655f14e261b',
          measurementId: 'G-YSFFNTZCQM'
        };
        vapidKey =
          'BODRnp7JGdITkqWm_SsLmJu_eKRGkgr8mkcN-yhMJvNFdY90mVJsTn_5gI1ckH74aiJafYHU0wj8jKA3zY0vrGE';
        break;

      case PKG_2:
        firebaseConfig = {
          apiKey: 'AIzaSyBiG3-EhwYJ__GACPS2J7rgPtmImc1NXsA',
          authDomain: 'fgip2-4s-rfid-com.firebaseapp.com',
          projectId: 'fgip2-4s-rfid-com',
          storageBucket: 'fgip2-4s-rfid-com.firebasestorage.app',
          messagingSenderId: '757421527230',
          appId: '1:757421527230:web:644b1e65359e0f59ccceef',
          measurementId: 'G-RR9JGV8JYT'
        };
        vapidKey =
          'BAW-nNS2rpx3sl8OI4PDEgNLr_3YhIiUwcQeSmR7pLnuHGWIW4dgvdfJa56PJxyoZxs2_1mkzowMn4mP8dApvcQ';
    }

    // 1) Firebase / Service Worker 등록
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then(async (registration) => {
          const token = await getToken(messaging, {
            vapidKey: vapidKey,
            serviceWorkerRegistration: registration
          });
          console.log('FCM Token:', token);
          setFcmToken(token);
        })
        .catch(console.error);
    }

    // 2) Foreground 메시지 수신 → 브라우저 Notification
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('포그라운드 메시지 수신:', payload);
      const { title = '', ...rest } = payload.notification ?? {};

      if (sosAudioRef.current && title === 'SOS' && pkgNo === PKG_2) {
        sosAudioRef.current.pause();
        sosAudioRef.current.currentTime = 0;
        sosAudioRef.current.play().catch((error) => {
          console.error('Audio play error:', error);
        });
      }

      showAlarm({
        modalTitle: 'SOS',
        message: rest.body,
        noFooter: false,
        isSingleFooter: true,
        closeButtonProps: {
          onClick: () => {
            closeAlarm();
          }
        }
      });
    });

    // 정리 함수
    return () => unsubscribe();
  }, [showAlarm, closeAlarm, setFcmToken, pkgNo]);
};
